export default __webpack_public_path__ + "static/media/button-cancel-sound.a6b12d1a.mp3";